import { AppContainer } from "@/components/layout/app-container"
import { Skeleton } from "@/components/ui/skeleton"
import { PageLoadingProps } from "../contrato.types"

export function PageLoading({
  title,
  description = "",
  button,
  layout = "details",
  children
}: PageLoadingProps) {
  const renderSkeleton = () => {
    if (children) return children

    switch (layout) {
      case "details":
        return (
          <div className="flex gap-8">
            <div className="w-[300px]">
              <Skeleton className="h-[600px] w-full rounded-[20px]" />
            </div>
            <div className="flex-1">
              <Skeleton className="h-[600px] w-full rounded-[20px]" />
            </div>
          </div>
        )
      case "form":
        return (
          <div className="flex gap-10">
            <Skeleton className="h-[800px] w-full max-w-[694px] rounded-[20px]" />
            <Skeleton className="h-[800px] flex-1 rounded-[20px]" />
          </div>
        )
      default:
        return (
          <Skeleton className="h-[600px] w-full rounded-[20px]" />
        )
    }
  }

  return (
    <AppContainer title={title} description={description} button={button}>
      {renderSkeleton()}
    </AppContainer>
  )
}
